
import store from "@/store";

class Chord {

	constructor (songs) {
		this.maxCountries = 7;
		this.maxFrequentArtists = 1000;

		this.songs = songs;
		this.countries = {};
		this.frequentArtists = {};

		this.mapCountries();
		//this.findFrequentArtists()
	}
    
	mapCountries() {
            
		var countries = {};

		this.songs.forEach(song => {

			// Destination Country

			let songCountry = song.country_origin;
			if (songCountry !== undefined && songCountry != "") {
				let country = countries[songCountry];
				countries[songCountry] = {
					count: (country === undefined) ? 1 : +country.count + 1,
					country: songCountry
				};
			}

			// Origin Country

			song = store.state.songs[song.parent_id];
			if (song !== undefined && song.country_origin !== undefined && song.country_origin != "") {
				let country = countries[song.country_origin];
				countries[song.country_origin] = {
					count: (country === undefined) ? 1 : +country.count + 1,
					country: song.country_origin
				};
			}
		});

    
		countries = Object.values(countries);
        
		// Sort by song frequency
		countries.sort((a, b) => {
			return b.count - a.count;
		});
        
		// Slice the top countries
		if (countries.length > this.maxCountries) {
			countries = countries.slice(0, this.maxCountries);
		}
    
		countries.push({
			count: 0,
			country: "Autres"
		});
        
		// Create a lookup object
    
		countries.forEach((c, i) => {
			this.countries[`${c.country}`] = {
				key: i,
				country: `${c.country}`
			};
		});
	}

	/**
     * Find the frequency of origin artists
     */
	findFrequentArtists() {
		let frequentArtists = {};

		this.songs.forEach(song => {
			let parent = store.state.songs[song.parent_id];

			if (parent && parent.artist != "") {
				if (frequentArtists[parent.artist] === undefined) {
					frequentArtists[parent.artist] = {
						artist: parent.artist,
						count: 1
					};
				} else {
					frequentArtists[parent.artist].count++;
				}
			}
		});

		this.frequentArtists = Object.values(frequentArtists).sort((a,b) => {
			return b.count - a.count;
		}).slice(0, this.maxFrequentArtists);
	}

	getChordData (filters) {

		let groups = this.calculateGroups();
		let matrix = this.calculateMatrix(filters);

		return {
			groups: groups,
			matrix: matrix
		};
	}

	calculateGroups () {
		return Object.values(this.countries).map(country => {
			return {
				name: country.country,
				color: country.color,
				key: country.key
			};
		});
	}

	calculateMatrix (filters) {

		let matrix = [];
        
		for (let i = 0; i < Object.keys(this.countries).length; i++) {
			matrix.push([]);
			for (let j = 0; j < Object.keys(this.countries).length; j++) {
				matrix[i][j] = 0;
			}
		}

		this.filterSongs(filters).forEach(s => {
			let otherCountry = this.countries["Autres"].key;
            
			let destinationCountryText = s.country_origin;
			let destinationCountry = (destinationCountryText != "" && this.countries[destinationCountryText]) ? this.countries[destinationCountryText].key : otherCountry;
            
			let parentSong = store.state.songs[s.parent_id];
			let parentCountryText = parentSong.country_origin;
			let originCountry = (parentCountryText != "" && this.countries[parentCountryText]) ? this.countries[parentCountryText].key : otherCountry;
            
			matrix[originCountry][destinationCountry]++;
		});

		this.validateMatrix(matrix);

		return matrix;
	}

	validateMatrix (matrix) {
		let valid = false;
		for (let i = 0; i < matrix.length && !valid; i++) {
			for (let j = 0; j < matrix.length && !valid; j++) {
				if (matrix[i][j] > 0) {
					valid = true;
				}
			}
		}

		if (!valid) {
			throw "Empty Matrix";
		}
	}

	filterSongs (filters) {
		return this.songs.filter(s => 
			s.parent_id != "" &&
            s.country_origin !== undefined &&
            s.country_origin != "" &&
            s.year >= filters.dateRange[0] &&
            s.year <= filters.dateRange[1] &&
            (
            	(filters.artist === null) ||
                (
                	filters.artist !== null && filters.direction == "target" && store.state.songs[s.parent_id][`${filters.role}_ids`].includes(filters.artist)
                ) || 
                (
                	filters.artist !== null && filters.direction == "source" && s[`${filters.role}_ids`].includes(filters.artist)
                )
            )
		);
	}
    
	getSongById(id) {
		let song = store.state.songs[id];

		if (song !== undefined) {
			return song;
		}

		return null;
	}
}

export default Chord;
